export const validateURL = (input: string) => {
    const urlPattern = '^((https?|ftp)://)?([\\w-]+\\.)+[\\w-]+(:\\d+)?(/[\\w-./?%&=]*)?$';
    const urlRegex = new RegExp(urlPattern);
    return  urlRegex.test(input);
  };
